export default "__VITE_ASSET__E2zkyfZQ__"